import { useContext } from 'react';

import AppointmentDetailContext from './AppointmentDetailContext';

const useAppointmentDetailContext = () => useContext(AppointmentDetailContext);

export default useAppointmentDetailContext;